import tw from 'tailwind-styled-components'

export const ContainerNav = tw.div`
flex 
justify-between 
gap-1 
`
export const NavProgressLine = tw.div`
pt-4 
relative 
cursor-pointer 
pb-2 
text-center 
font-medium 
text-[13px] 
text-darkGray 
w-full
group
hover:bg-gray-100
rounded-sm
`
export const NavProgressLineText = tw.span`
flex
justify-center
gap-2
items-center
font-medium
text-[13px]
text-darkGray
`

export const Mt8px = tw.div`
mt-2
`

export const GridProgressLine = tw.div`
grid 
gap-1 
w-full 
relative
`
export const BackLineProgress = tw.div`
w-full 
bg-gray-100 
h-[2px] 
absolute 
top-[11px]
`

export const CurrentProgressStyle = tw.div`
w-full 
z-10 
h-[5px] 
absolute 
top-2
`
